import { IDataFlowPlainObjects } from 'worker/app-workers/shared/models/dataflow-plainObject-parser';
import { WorkerService } from 'app/services/worker/worker.service';
import { WorkerMessage } from 'worker/app-workers/shared/worker-message.model';
import { WORKERTOPIC } from 'worker/app-workers/shared/worker-topic.constants';
import {
    IDataFlowParserRequestMessage,
    IDataFlowParserResponseMessage
} from 'worker/app-workers/shared/dataflow.parser.message';
import { IDataFlowPOParser, IDataFlowPOParserWorkerOptions } from './IDataFlowPOParser';
import { generateUUID } from 'app/shared/utils/uuid.util';
import { format } from 'app/shared/utils/string.util';
import { filter, take } from 'rxjs/operators';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { IResourceContext } from 'shell-models-lib';
import { LoggerService } from 'app/logger/logger.service';

export class RemoteDataFlowPOParser implements IDataFlowPOParser {
    public async parseDSL(contextData: IResourceContext, script: string, dataFlowName: string, option?: Partial<IDataFlowPOParserWorkerOptions>): Promise<IDataFlowPlainObjects> {
        const nonNullableOption: Partial<IDataFlowPOParserWorkerOptions> = option ?? {};
        const workerService = await getServiceInstance<WorkerService>(contextData, 'WorkerService');

        const request: IDataFlowParserRequestMessage = {
            name: dataFlowName,
            script,
            option: nonNullableOption
        };
        const id = generateUUID();

        const responseObservable = workerService.workerUpdate$.pipe(filter(
            (message) => message.topic === WORKERTOPIC.dataFlowParseDSL && message.id === id)).pipe(take(1));

        workerService.doWork(new WorkerMessage(WORKERTOPIC.dataFlowParseDSL, id, request), !!(nonNullableOption.fastQueue));
        const response = await responseObservable.toPromise();

        const message = response.data as IDataFlowParserResponseMessage;
        if (message.succeeded) {
            return message.plainObjects;
        } else {
            const loggerService = await getServiceInstance<LoggerService>(contextData, 'LoggerService');
            loggerService.error('RemoteDataFlowPOParser', `Failed to parse ${dataFlowName}'s script due to ${message.errorMessage}`);
            throw new Error(format(stringResources.DataFlowEditorErrorUnableToParse, dataFlowName));
        }
    }
}
